<template>
  <div class="home">
    <!-- 英雄区域 -->
    <section class="hero">
      <div class="hero-content">
        <h1>{{ companyName }}</h1>
        <p class="slogan">{{ slogan }}</p>
        <div class="hero-buttons">
          <router-link to="/technology" class="btn btn-primary">了解技术</router-link>
          <router-link to="/products" class="btn btn-secondary">探索产品</router-link>
        </div>
      </div>
    </section>

    <!-- 核心理念 -->
    <section class="core-concept">
      <div class="container">
        <h2 class="section-title">核心理念</h2>
        <div class="concept-content">
          <div class="concept-text">
            <h3>用AI让每一个硬件拥有智能</h3>
            <p>矢量律动致力于打破人机交互的壁垒，通过智能体平台和先进的AI算法，让人工智能成为人类的得力助手和沟通伙伴。我们相信，人与AI的和谐共处将开启科技新纪元。</p>
          </div>
          <div class="concept-image">
            <img src="@/assets/images/icons/用AI让每一个硬件拥有智能.png" alt="用AI让每一个硬件拥有智能" />
          </div>
        </div>
      </div>
    </section>

    <!-- 技术能力简介 -->
    <section class="tech-preview">
      <div class="container">
        <h2 class="section-title">核心技术</h2>
        <div class="tech-cards">
          <div class="tech-card" v-for="tech in techPreview" :key="tech.id">
            <div class="tech-icon">
              <span class="material-symbols-outlined">{{ tech.iconName }}</span>
            </div>
            <h3>{{ tech.name }}</h3>
            <p>{{ tech.description }}</p>
          </div>
        </div>
        <div class="more-link">
          <router-link to="/technology">了解更多技术能力 →</router-link>
        </div>
      </div>
    </section>

    <!-- 产品展示 -->
    <section class="product-showcase">
      <div class="container">
        <h2 class="section-title">应用场景</h2>
        <div class="product-carousel">
          <div class="product-item" v-for="(product, index) in productShowcase" :key="index">
            <div class="product-image">
              <template v-if="hasIcon(product.name)">
                <img :src="require(`@/assets/images/icons/${product.name}.png`)" :alt="product.name" />
              </template>
              <div v-else class="image-placeholder">{{ product.name }}</div>
            </div>
            <h3>{{ product.name }}</h3>
          </div>
        </div>
        <div class="more-link">
          <router-link to="/products">探索更多产品 →</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'HomeView',
  data() {
    return {
      companyName: '矢量律动',
      slogan: '用AI让每一个硬件拥有智能',
      techPreview: [
        {
          id: 1,
          name: '多样算法能力',
          description: '包含音、视、图、文等多类型、多模态算法落地能力。',
          iconName: 'functions'
        },
        {
          id: 2,
          name: '硬件智能体平台',
          description: '具备多样丰富的多算法、多场景、适配多硬件的AI智能体平台',
          iconName: 'developer_board'
        },
        {
          id: 3,
          name: '多设备集成管理',
          description: '无缝对接和管理多场景、多类型的智能硬件',
          iconName: 'hub'
        }
      ],
      productShowcase: [
        {
          name: '智能耳机',
          image: null
        },
        {
          name: '智能眼镜',
          image: null
        },
        {
          name: '智能手表',
          image: null
        },
        {
          name: '智能音箱',
          image: null
        },
        {
          name: '智能键盘',
          image: null
        },
        {
          name: '智能玩具',
          image: null
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getCompanyInfo', 'getTechCapabilities', 'getProducts'])
  },
  methods: {
    ...mapActions(['fetchCompanyInfo', 'fetchTechCapabilities', 'fetchProducts']),
    
    hasIcon(name) {
      const availableIcons = ['智能耳机', '智能眼镜', '智能手表', '智能音箱', '智能键盘', '智能玩具'];
      return availableIcons.includes(name);
    }
  },
  async mounted() {
    // await this.fetchCompanyInfo()
    // await this.fetchTechCapabilities()
    // await this.fetchProducts()
    //
    // // 如果API数据获取成功，则更新页面数据
    // if (this.getCompanyInfo) {
    //   this.companyName = this.getCompanyInfo.name
    //   this.slogan = this.getCompanyInfo.slogan
    // }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
}

.hero {
  height: 100vh;
  background: linear-gradient(135deg, #3a1c71, #d76d77, #ffaf7b);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hero-content {
  max-width: 800px;
  padding: 0 20px;
}

.hero h1 {
  font-size: 4rem;
  margin-bottom: 20px;
  animation: fadeIn 1s ease-in;
}

.slogan {
  font-size: 1.8rem;
  margin-bottom: 40px;
  animation: fadeIn 1.5s ease-in;
}

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  animation: fadeIn 2s ease-in;
}

.btn {
  padding: 12px 30px;
  border-radius: 30px;
  font-size: 1.1rem;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #d76d77, #ffaf7b);
  color: white;
  border: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #ffaf7b, #d76d77);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
  background-color: transparent;
  border: 2px solid white;
  color: white;
}

.btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.placeholder-image {
  width: 100%;
  height: 300px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 1.2rem;
  color: #555;
}

.icon-placeholder {
  width: 80px;
  height: 80px;
  background-color: #3a1c71;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 0 auto;
}

.image-placeholder {
  width: 100%;
  height: 200px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 1.2rem;
  color: #555;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 60px;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #3a1c71, #d76d77);
}

.core-concept {
  background-color: #f9f9f9;
}

.concept-content {
  display: flex;
  align-items: center;
  gap: 50px;
}

.concept-text {
  flex: 1;
}

.concept-text h3 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #3a1c71;
}

.concept-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
}

.concept-image {
  flex: 1;
  text-align: center;
}

.concept-image img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.tech-cards {
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.tech-card {
  background-color: white;
  padding: 40px 30px;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  flex: 1;
  min-width: 250px;
  max-width: 350px;
  text-align: center;
  transition: transform 0.3s ease;
}

.tech-card:hover {
  transform: translateY(-10px);
}

.tech-icon {
  margin-bottom: 20px;
  width: 80px;
  height: 80px;
  background-color: rgba(58, 28, 113, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

.tech-icon span.material-symbols-outlined {
  font-size: 2.5rem;
  color: #3a1c71;
}

.tech-card h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #3a1c71;
}

.tech-card p {
  color: #666;
  line-height: 1.6;
}

.more-link {
  text-align: center;
  margin-top: 40px;
}

.more-link a {
  color: #3a1c71;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  transition: color 0.3s ease;
}

.more-link a:hover {
  color: #d76d77;
}

.product-showcase {
  background-color: #f0f0f0;
}

.product-carousel {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding: 20px 0;
  scroll-snap-type: x mandatory;
}

.product-item {
  flex: 0 0 auto;
  width: 260px;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  scroll-snap-align: center;
  transition: transform 0.3s ease;
}

.product-item:hover {
  transform: scale(1.03);
}

.product-image {
  height: 200px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.product-item:hover .product-image img {
  transform: scale(1.05);
}

.product-item h3 {
  padding: 15px;
  text-align: center;
  font-size: 1.2rem;
  color: #3a1c71;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 3rem;
  }
  
  .slogan {
    font-size: 1.4rem;
  }
  
  .concept-content {
    flex-direction: column;
  }
  
  .tech-card {
    min-width: 100%;
  }
}
</style> 